import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack, styled } from "@mui/material";
import { useMemo } from "react";
import PurchaseFreePassTab from "./PurchaseFreePassTab";
import PurchaseModals from "./PurchaseModals";
import PurchaseNoFreepassTab from "./PurchaseNoFreepassTab";
import PurchaseTabs from "./PurchaseTabs";
import PurchaseUnavailableTab from "./PurchaseUnavailbleTab";
const PurchaseRoot = styled(Stack)((param)=>{
    let { theme  } = param;
    return {
        maxHeight: "calc(100vh - 219px)",
        backgroundColor: theme.palette.common.white,
        borderRadius: "12px",
        boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.04)",
        padding: theme.spacing(2.5),
        width: "100%",
        border: "1px solid ".concat(theme.palette.grey[50])
    };
});
const getPurchaseState = (product, isLoggedIn, hasUsableFreepass)=>{
    if (!product.available) return "unavailable";
    const source = product.source;
    if ((source === null || source === void 0 ? void 0 : source.type) === "freepass") {
        if (!hasUsableFreepass || !isLoggedIn) return "noFreepass";
        return "freepass";
    }
    return "default";
};
const PurchaseSection = (param)=>{
    let { sx , product , hasUsableFreepass , isLoggedIn , fullWidth  } = param;
    const purchaseContent = useMemo(()=>{
        const purchaseState = getPurchaseState(product, isLoggedIn, hasUsableFreepass);
        switch(purchaseState){
            case "default":
                return /*#__PURE__*/ _jsx(PurchaseTabs, {
                    isLoggedIn: isLoggedIn,
                    product: product,
                    fullWidth: fullWidth
                });
            case "freepass":
                return /*#__PURE__*/ _jsx(PurchaseFreePassTab, {
                    isLoggedIn: isLoggedIn,
                    product: product,
                    fullWidth: fullWidth
                });
            case "noFreepass":
                return /*#__PURE__*/ _jsx(PurchaseNoFreepassTab, {
                    product: product
                });
            case "unavailable":
                return /*#__PURE__*/ _jsx(PurchaseUnavailableTab, {});
            default:
                return null;
        }
    }, [
        product,
        hasUsableFreepass,
        isLoggedIn
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PurchaseRoot, {
                sx: sx,
                children: purchaseContent
            }),
            /*#__PURE__*/ _jsx(PurchaseModals, {
                product: product
            })
        ]
    });
};
export default PurchaseSection;
